import { createContext, useContext, useState } from "react";
import { COPY } from "./content";

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState("it");
  const t = COPY[lang];
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
